// extracted by mini-css-extract-plugin
export var core = "Gallery-module--core--84f6f";
export var modal = "Gallery-module--modal--c1114";
export var slide = "Gallery-module--slide--6e25b";
export var video = "Gallery-module--video--450f0";